import application from "../application";

export default class Configs {
    /**
     *
     * @param {application} app
     */
    constructor(app) {
        this.app = app;
        this.API = app.API

        this.list = []
        this.selection = []
        this.selectionMode = false
    }

    async refresh() {
        this.list = await this.API.getProjectsTree()

        // Afegir propietat "selected"
        this.cleanSelection()
    }

    cleanSelection(list) {
        list = list ? list : this.list

        if (list) {
            // iterate projects
            list.forEach((project, index) => {
                project.selected = false

                // iterate configs
                project.configurations.forEach((config, index) => {
                    config.selected = false
                })
            })
        }
    }

    selectEntireProject(projectId) {
        // iterate projects
        console.log(projectId)
        this.list.forEach((project, index) => {
            // iterate configs
            if (project.id === projectId) {
                project.configurations.forEach((config, index) => {
                    config.selected = true
                })
            }
        })

        // force refresh
        this.list = this.list
    }
    deselectEntireProject(projectId) {
        // iterate projects
        this.list.forEach((project, index) => {
            // iterate configs
            if (project.id == projectId) {
                project.configurations.forEach((config, index) => {
                    config.selected = false
                })
            }
        })
    }

    getSelectedConfigurationsIds(project) {
        var result = []
        var list = project ? [project] : this.list

        if (list) {
            // iterate projects
            list.forEach((project, index) => {
                // iterate configs
                project.configurations.forEach((config, index) => {
                    if (config.selected == true) {
                        result.push(config.id)
                    }
                })
            })
        }

        return result
    }

}